import React from 'react';

// Nothing in the tree caught render errors, so any throw during render blanked
// the whole app — React unmounts everything when no boundary handles it. That
// is worst exactly where the numbers matter most: the Workday preview reads a
// dozen fields off one response to show an IT admin what a sync would do, and a
// single missing count took the page down instead of the count.
//
// `resetKey` is what stops a crashed page from staying crashed: the error state
// survives until something tells the boundary its subtree changed, so without
// it, clicking another nav link kept showing this fallback. Layout passes the
// current pathname.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.reset = () => this.setState({ error: null });
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.reset();
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', gap: 12, padding: 40, minHeight: 320,
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 32 }}>⚠</div>
        <h2 style={{ fontSize: 16, fontWeight: 600 }}>This page hit an error</h2>
        <p style={{ color: 'var(--text-2)', fontSize: 14, maxWidth: 460, lineHeight: 1.6 }}>
          Nothing was changed by the failure. Try again, and if it keeps
          happening send IT the message below.
        </p>
        {/* Shown rather than swallowed: the people using this are the people who
            would be debugging it. */}
        <div className="mono" style={{
          fontSize: 12, color: 'var(--text-2)', background: 'var(--bg-2)',
          border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
          padding: '8px 12px', maxWidth: 520, overflowWrap: 'anywhere',
        }}>
          {error.message || String(error)}
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
          <button className="btn btn-primary" onClick={this.reset}>Try again</button>
          <button className="btn" onClick={() => window.location.reload()}>Reload page</button>
        </div>
      </div>
    );
  }
}
